import { Link } from "react-router-dom";

import Button from "@mui/material/Button";
import PickYourDish from "../assets/pick your dish.png";
import FindYourSpot from "../assets/find your spot.png";
import MeetUp from "../assets/meet up.png";

function HowItWorks() {
  return (
    <div className="howitworks">
      <h2>How Fudopia Works</h2>

      <div className="steps-grid">
        <div className="step">
          <img
            src={PickYourDish}
            alt="Cartoon illustration of a noodle bowl, bubble tea, dumpling, and curry bowl with a yellow star on a blue background."
          />
          <h3>1. Find a dish or drink you want to try</h3>
          <p>
            From saucy noodles to spicy soups to refreshing Thai teas, we
            feature Bangkok’s must-try food and drinks. Scroll, explore, and
            pick what sounds delicious.
          </p>
        </div>

        <div className="step">
          <img
            src={FindYourSpot}
            alt="Cartoon map pin with a café table inside and a yellow checkmark on a pale map background."
          />
          <h3>2. Choose a spot & make it happen</h3>
          <p>
            We’ll suggest great restaurants and cafés for each pick. Join an
            event that’s already happening or start your own in just a few taps.
          </p>
        </div>

        <div className="step">
          <img
            src={MeetUp}
            alt="Cartoon of four people sitting around a table sharing noodles, dumplings, and drinks."
          />
          <h3>3. Eat well. Meet people. Repeat.</h3>
          <p>
            Each event is limited to 4 guests. Small, friendly, and made for
            real conversations over great food and drinks.
          </p>
        </div>
      </div>

      <p>
        <Link to="/faq">
          <Button color="primary" variant="contained">
            Learn more in our FAQ
          </Button>
        </Link>
      </p>
    </div>
  );
}

export default HowItWorks;
